import React from "react";

export default function HandIcon({
  size = 20,
  className,
  ...rest
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0328 5.75H4.96727C4.57277 5.75 4.25002 5.42725 4.25002 5.03275V3.21725C4.25002 2.82275 4.57277 2.5 4.96727 2.5H12.0328C12.4273 2.5 12.75 2.82275 12.75 3.21725V5.03275C12.75 5.42725 12.4273 5.75 12.0328 5.75Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.85873 11.5C4.52398 11.5 4.24998 11.7898 4.24998 12.144V15.25C4.24998 15.3237 4.25223 15.3975 4.25673 15.4707C4.28898 15.9905 4.51073 16.4813 4.85198 16.8745C5.11748 17.1805 5.49998 17.5 5.99998 17.5H11C11.5 17.5 11.8825 17.1805 12.1482 16.8745C12.4892 16.4813 12.7112 15.9905 12.7432 15.4707C12.7477 15.3975 12.75 15.3237 12.75 15.25V11.5H4.85873Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.125 9.5C10.6418 9.5 10.25 9.10825 10.25 8.625C10.25 8.14175 10.6418 7.75 11.125 7.75C11.6083 7.75 12 8.14175 12 8.625C12 9.10825 11.6083 9.5 11.125 9.5ZM12.8065 6.75H4.1935C3.94975 6.75 3.75 6.94975 3.75 7.1935V10.0565C3.75 10.3003 3.94975 10.5 4.1935 10.5H12.8065C13.0503 10.5 13.25 10.3003 13.25 10.0565V7.1935C13.25 6.94975 13.0503 6.75 12.8065 6.75Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7504 15.2736L15.7619 13.2376C16.0744 12.9251 16.2501 12.5014 16.2501 12.0594V10.1006C16.2501 9.60637 15.9321 9.14487 15.4514 9.02937C14.8054 8.87387 14.2289 9.35938 14.2289 9.97937V11.0054C14.2289 11.2774 14.0066 11.4996 13.7346 11.4996"
          fill="black"
        />
      </g>
    </svg>
  );
}

export const HandWideIcon = ({ size = 40 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.677 18.0259C28.1161 17.7059 27.3619 17.8506 27.0015 18.3471L24.9693 21.1453L24.9646 21.1524H24.9634C24.8513 21.3059 24.6555 21.4071 24.4326 21.3994C24.1006 21.3865 23.8417 21.1394 23.8559 20.8465L23.9361 20.0524L24.0894 18.5441L24.7558 11.9935C24.816 11.4041 24.3218 10.8794 23.6577 10.8265C22.9937 10.7735 22.4016 11.2112 22.3414 11.8L21.7635 17.4765V17.4753C21.7558 17.6359 21.6019 17.7606 21.4197 17.7535C21.2374 17.7476 21.0965 17.6112 21.1041 17.4512V11.0747C21.1041 10.4835 20.5586 10 19.8916 10C19.2252 10 18.6791 10.4835 18.6791 11.0753V17.5606C18.6715 17.7212 18.5176 17.8453 18.3359 17.8388C18.1922 17.8386 18.0669 17.7413 18.0316 17.6024H18.0245L17.1788 11.7812C17.0939 11.1947 16.483 10.7765 15.8219 10.8518C15.1608 10.9282 14.6896 11.4694 14.7745 12.0559L15.6544 18.1088H15.6532L15.6473 18.1106C15.6514 18.1318 15.6597 18.1518 15.6585 18.1741C15.6508 18.3347 15.4969 18.4594 15.3153 18.4524C15.175 18.4521 15.0518 18.3596 15.0127 18.2253L15.0074 18.2259L13.9253 14.5082C13.7584 13.9353 13.0937 13.5876 12.448 13.7359C11.8028 13.8829 11.4106 14.4729 11.5775 15.0459L14.3275 24.4947C14.3275 24.4947 14.4655 25.0694 15.2976 26.0012L15.3035 26C15.4338 26.1612 15.5777 26.3141 15.7304 26.46V29.3C15.7304 29.6853 16.0855 30 16.5195 30H22.299C22.733 30 23.0886 29.6853 23.0886 29.3V27.0376C23.3389 26.8715 23.5748 26.6848 23.7939 26.4794L23.7998 26.4818C24.2451 26.1041 24.7729 25.3859 24.7729 25.3859L29.0391 19.5118C29.4006 19.0147 29.2372 18.3459 28.6764 18.0259"
          fill="#222222"
        />
      </g>
    </svg>
  );
};
